<template>
    <div>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
              <div class="col-md-12">
                <router-link :to="{ name: 'pembukuan-pemasukkan-tambah'}"  class="btn btn-primary" >Tambah Pemasukkan</router-link>
              </div>
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header card-header-info">
                    <div class="row">
                      <div class="col-md-6 mr-auto">
                        <h4 class="card-title ">Pemasukkan</h4>
                        <p class="card-category">Semua Pemasukkan yang di terima pada bulan yang di tentukan</p>
                      </div>
                      <div class="col-md-2">
                        <p class="card-title text-right">Total</p>
                        <h4 class="card-title text-right"><strong>{{myGlobal.ribu(theGet.data.Total)}}</strong></h4>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table">
                        <thead class=" text-info">
                          <th width="40px">No.</th>
                          <th>Admin</th>
                          <th>Keterangan</th>
                          <th>Jumlah</th>
                          <th>Tanggal </th>
                          <th></th>
                        </thead>
                          <!-- LOADING -->
                        <tbody v-show="data.loading">
                          <tr>
                            <td colspan="8"><Loading></Loading></td>
                          </tr>
                          <tr>
                            <td colspan="8"><Loading></Loading></td>
                          </tr>
                          <tr>
                            <td colspan="8"><Loading></Loading></td>
                          </tr>
                        </tbody>
                          <!-- DATA -->
                        <tbody v-show="!data.loading">
                          <tr v-for="(u, index) in theGet.data.List">
                            <td>{{ index+1 }}</td>
                            <td>{{ u.by }}</td>
                            <td>{{ u.keterangan }}</td>
                            <td>{{ myGlobal.ribu(u.jumlah) }}</td>
                            <td>{{u.jam}}<br><strong class="text-success">{{ myGlobal.tglIndo(u.tanggal) }}</strong></td>
                          </tr>
                          <!-- NULL -->
                          <tr v-if="theGet.data.List == null">
                            <td></td>
                            <td>Tidak ada Data </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
	components: { 
      "Loading" : Loading
	}, 
  setup() {
    const data = reactive({
        loading: true
    })

    const theGet = {
        data: reactive({
            List: [],
            Total: "0",
        }),
        datae() {
            var datax = {
                token: 'TangTung '+sessionStorage.getItem('myToken'),
                bulan: sessionStorage.getItem('bulanIdBase'),
                tahun: sessionStorage.getItem('tahunBase'),
                filter: "masuk"
            };
        
            var apiUrl = inter.Pengeluaran();
            myGlobal.call(datax,apiUrl).then(x => {
                data.loading = false;
                if (x.status == true) {
                    this.data.List = x.data;
                    this.data.Total = x.pesan.masuk;
                
                } else {
                theGet.data.List = null;
                }
            })
        }
    }
    return {
      data,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Pemasukkan";

    this.data.namaQ = sessionStorage.getItem('admin');
    this.theGet.datae();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/pembukuan/pemasukkan.vue